module.exports = __webpack_public_path__ + "img/certificates.dba1ad9a.svg";